<template>
	<div>
		<v-container>
			<v-row>
				<v-col lg="12" class="pt-2 pb-1">
					<s-crud title="Recepción Refrescos / Pedidos" height="auto" searchInput add @save="save($event)"
						@addEvent="addEvent()" edit @EditEvent="editEvent()" ref="gridReceptionFresh" :config="config"
						:filter="filterSchedule" @doubleClick="doubleClick($event)" no-full :showGroupBy="false" remove>
						<template scope="props">
							<v-row justify="center">
								<v-col cols="4" md="4" lg="4" v-if="EditData == 0">
									<s-select-producer label="Productor" :text="props.item.PrdCardName"
										v-model="ProducerObjSelected" return-object
										@input="inputProducer($event)"></s-select-producer>
									<div style="color: #FF0000; font-size: 10px; padding-top: 3px;"
										v-if="HasSomeCertificateDefeated == 1">
										{{ "Productor(a) tiene certificados incompletos y/o vencidos." }}
									</div>
								</v-col>
								<v-col cols="4" md="4" lg="4" v-if="EditData == 1">
									<s-text label="Productor:" v-model="ProducerObjSelected.NameProducer"
										disabled></s-text>
								</v-col>
								<v-col cols="4" md="4" lg="4">
									<s-text label="Cantidad Jabas:" v-model="ProducerObjSelected.QuantityJabas"
										placeholder="0" type="number"></s-text>
								</v-col>
								<v-col cols="4" md="4" lg="4">
									<s-select-definition label="Tipo de Calibre" :def="1190"
										v-model="ProducerObjSelected.CaliberOrder" clearable />
								</v-col>
							</v-row>
							<v-row justify="start">
								<v-col cols="4" md="4" lg="4">
									<s-select-definition label="Estado Certificado" :def="1622"
										v-model="ProducerObjSelected.StatusCertificate" clearable />
									<!-- 1043 ó 1159 -->
								</v-col>
							</v-row>
						</template>
						<template v-slot:filter>
							<v-container>
								<v-row justify="center" class="s-col-form">
									<v-col lg="3">
										<s-date label="Fecha Inicio" v-model="filterSchedule.BeginDate"></s-date>
									</v-col>
									<v-col lg="3">
										<s-date label="Fecha Fin" v-model="filterSchedule.EndDate"></s-date>
									</v-col>
									<v-col lg="3">
										<s-select-definition label="Estado Certificación" :def="1622"
											v-model="filterSchedule.StatusCertificate" clearable />
									</v-col>
								</v-row>
							</v-container>
						</template>
						<template v-slot:CaliberOrder="{ row }">
							<v-chip x-small color="info">
								{{ getTextCaliber(row.CaliberOrder) }}
							</v-chip>
						</template>
						<template v-slot:StatusCertificate="{ row }">
							<v-chip x-small :color="getColor(row.StatusCertificate)">
								{{ getText(row.StatusCertificate) }}
							</v-chip>
						</template>
					</s-crud>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import _sOrders from "@/services/FreshProduction/PrfOrdersService";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer.vue";

export default {
	components: { SSelectProducer },
	// props: {},
	data: () => ({
		HasSomeCertificateDefeated: 3,
		EditData: 0,
		ProducerObjSelected: {
			CaliberOrder: null,
			DocumentNumber: null,
			FullName: null,
			PersonText: null,
			PrdAddress: null,
			PrdCardCode: null,
			PrdCardName: null,
			NameProducer: null,
			OrpID: null,
			PrdID: null,
			PrdStatus: null,
			PrdStatusSap: null,
			PrsDocumentNumber: null,
			PrsID: null,
			SecCreate: null,
			SecStatus: null,
			SecUpdate: null,
			StatusCertificate: null,
			SzoDescription: null,
			TypePrice: null,
			TypeProducer: null,
			TypeProducerText: null,
			TypeSupplier: null,
			TypeSupplierText: null,
			UsrCreateID: null,
			UsrUpdateID: null,
			ZonDescription: null,
			QuantityJabas: null
		},
		filterSchedule: { BeginDate: null, EndDate: null, StatusCertificate: null },
		config: {
			model: {
				OrpID: "ID",
				SecCreate: "date"
			},
			service: _sOrders,
			headers: [
				{ text: "ID", value: "OrpID", width: 60 },
				{ text: "Nombre Productor", value: "NameProducer" },
				{ text: "Cant. Jabas", value: "QuantityJabas" },
				{ text: "Calibre", value: "CaliberOrder" },
				{ text: "Fecha", value: "SecCreate", width: 100 },
				{ text: "Estado Certificado", value: "StatusCertificate", width: 140 }
			],
		}
	}),
	methods: {
		getTextCaliber(idCaliber){
			switch (idCaliber) {
				case 1: return 'GRANDE'
				case 2: return 'MEDIANO'
				case 3: return 'PEQUEÑO'
				case 4: return 'DESCARTE'
				default: return '-'
			}
		},
		getColor(text) {
			switch (text) {
				case 1: return 'success'
				default: return 'error'
			}
		},
		getText(idCertificate) {
			switch (idCertificate) {
				case 1: return 'Activo'
				default: return "Vencido"
			}
		},
		addEvent() {
			this.EditData = 0;
			this.ClearData();
		},
		ClearData() {
			this.ProducerObjSelected.CaliberOrder = null;
			this.ProducerObjSelected.DocumentNumber = null;
			this.ProducerObjSelected.FullName = null;
			this.ProducerObjSelected.PersonText = null;
			this.ProducerObjSelected.PrdAddress = null;
			this.ProducerObjSelected.PrdCardCode = null;
			this.ProducerObjSelected.PrdCardName = null;
			this.ProducerObjSelected.NameProducer = null;
			this.ProducerObjSelected.PrdID = null;
			this.ProducerObjSelected.PrdStatus = null;
			this.ProducerObjSelected.PrdStatusSap = null;
			this.ProducerObjSelected.PrsDocumentNumber = null;
			this.ProducerObjSelected.PrsID = null;
			this.ProducerObjSelected.SecCreate = null;
			this.ProducerObjSelected.SecStatus = null;
			this.ProducerObjSelected.SecUpdate = null;
			this.ProducerObjSelected.StatusCertificate = null;
			this.ProducerObjSelected.SzoDescription = null;
			this.ProducerObjSelected.TypePrice = null;
			this.ProducerObjSelected.TypeProducer = null;
			this.ProducerObjSelected.TypeProducerText = null;
			this.ProducerObjSelected.TypeSupplier = null;
			this.ProducerObjSelected.TypeSupplierText = null;
			this.ProducerObjSelected.UsrCreateID = null;
			this.ProducerObjSelected.UsrUpdateID = null;
			this.ProducerObjSelected.ZonDescription = null;
			this.ProducerObjSelected.QuantityJabas = null;
			this.ProducerObjSelected.OrpID = null;
		},
		save(event) {
			if ((this.ProducerObjSelected.PrdID == null
				|| this.ProducerObjSelected.QuantityJabas == 0
				|| this.ProducerObjSelected.CaliberOrder == 0
				|| this.ProducerObjSelected.StatusCertificate == null) && this.EditData == 1) {
				this.$fun.alert("Seleccione un registro para actualizar.", "warning");
				return;
			}
			if (
				this.ProducerObjSelected.PrdID == null
				|| this.ProducerObjSelected.QuantityJabas == 0
				|| this.ProducerObjSelected.CaliberOrder == 0
				|| this.ProducerObjSelected.StatusCertificate == null
			) {
				this.$fun.alert("Debe de completar todos los campos.", "warning");
				return;
			}

			var parameters = {
				OrpID: this.EditData == 0 ? 0 : this.ProducerObjSelected.OrpID,
				PrdID: this.ProducerObjSelected.PrdID,
				QuantityJabas: this.ProducerObjSelected.QuantityJabas,
				CaliberOrder: this.ProducerObjSelected.CaliberOrder,
				StatusCertificate: this.ProducerObjSelected.StatusCertificate,
				SecStatus: 1,
				UsrCreateID: this.EditData == 0 ? this.$fun.getUserID() : null,
				UsrUpdateID: this.EditData == 1 ? this.$fun.getUserID() : null,
				SecUpdate: null
			};

			if (this.EditData) {
				this.$fun.alert("¿ Esta seguro de Actualizar este registro ?", "question")
					.then((x) => {
						if (x.value) {
							_sOrders.save(parameters, this.$fun.getUserID())
								.then((resp) => {
									if (resp.status == 200) {
										this.ClearData();
										this.$refs.gridReceptionFresh.refresh();
										this.$fun.alert("Recepción de pedido actualizado.", "success");
										return;
									}
								})
						}
					});
			} else {
				_sOrders.save(parameters, this.$fun.getUserID())
					.then((resp) => {
						if (resp.status == 200) {
							this.ClearData();
							this.$refs.gridReceptionFresh.refresh();
							this.$fun.alert("El nuevo registro se agregado con éxito.", "success");
							return;
						}
					})
			}
		},
		inputProducer(producer) {
			if (producer == null) return;

			_sOrders.getCertificates({ "PrdID": producer.PrdID }, this.$fun.getUserID())
				.then((resp) => {
					if (resp.status == 200 && resp.data != null) {

						if (resp.data.HasSomeCertificateDefeated > 0) {
							this.HasSomeCertificateDefeated = 1;
							return;
						} else {
							this.HasSomeCertificateDefeated = 0;
							return;
						}
					}
					this.HasSomeCertificateDefeated = 0;
					return;
				})
		},
		editEvent() {
			this.EditData = 1;
		},
		doubleClick(event) {
			this.EditData = 1;
			if (event == null) return;
			this.ProducerObjSelected = { ...this.ProducerObjSelected, ...event };
			this.$emit("input", this.ProducerObjSelected);
		},
	}
}
</script>
